export enum APP_ACTIONS {
  INIT_USER = 'INIT_USER',
}

export enum APP_LOADERS {}
